import React from "react";
import { NavLink } from 'react-router-dom';
import { getUserInfo } from '../../services/User';

import "./NavBar.css";

function NavBar() {
  const user = getUserInfo();
  return (
    <nav className="nav">
      {/* Dashboard Link - Only for Admins */}
      {user?.user_type_id === 1 && (
        <div className="nav-link-container">
          <NavLink
            to="/dashboard"
            className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
          >
            Dashboard
          </NavLink>
        </div>
      )}
      
      <div className="nav-link-container">
        <NavLink
          to="/home"
          className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
        >
          Home
        </NavLink>
      </div>
      <div className="nav-link-container">
        <NavLink
          to="/stats"
          className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
        >
          Stats
        </NavLink>
      </div>
      <div className="nav-link-container">
        <NavLink
          to="/booknook"
          className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
        >
          Book Nook
        </NavLink>
      </div>
    </nav>
  );
};


export default NavBar;